import React from 'react';

export default () => {
  return (
  <header>
    <ul className="nav justify-content-end navbar-dark bg-dark">
      <li className="nav-item">
        <span className="navbar-text">
        XXV Ibero-American Conference on Software Engineering (CIbSE 2022)
        </span>
      </li>
      <li className="nav-item active">
       <a className="nav-link" href="https://github.com/alinebrito/refgraph-fowler-study" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-github" aria-hidden="true"></i> GitHub</a>
      </li>
        <li className="nav-item active">
      <a className="nav-link" href={`${process.env.PUBLIC_URL}`}><i className="fas fa-home" aria-hidden="true"></i> Home</a>
      </li>
    </ul>
    <div className="jumbotron jumbotron-fluid">
      <div className="container">
        <div className="row">
          <div className="col-9">
            <h2 className="">Understanding Refactoring Tasks over Time:</h2>
            <h2 className="">A Study Using Refactoring Graphs</h2>
          </div>
        </div>
      </div>
    </div>
  </header>
  );
};